<template>
  <div class="tw-space-y-4">
    <div class="tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-3">
      <h2 class="tw-text-lg tw-font-semibold tw-tracking-tight tw-text-slate-900">
        Carrier: {{ brokerCarrierAssociation.customCarrierName }}
      </h2>
      <div class="tw-text-sm tw-text-slate-600">Status: {{ brokerCarrierAssociation.onboardingStatus }}</div>
    </div>

    <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4">
      <div class="tw-text-sm tw-font-semibold tw-text-slate-900">General Information</div>
      <div class="tw-mt-2 tw-space-y-1 tw-text-sm tw-text-slate-700">
        <div>Email: {{ carrier.email }}</div>
        <div>Onboarding Status: {{ brokerCarrierAssociation.onboardingStatus }}</div>
        <div v-if="brokerCarrierAssociation.onboardingStatus === 'In Progress'">
          Onboarding link:
          <a class="tw-font-medium tw-text-slate-900 hover:tw-underline" :href="getCarrierOnboardingUrl()">link</a>
        </div>
      </div>
    </div>

    <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4">
      <div class="tw-text-sm tw-font-semibold tw-text-slate-900">Onboarding Information</div>
      <div class="tw-mt-2 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-6 tw-gap-y-2 tw-text-sm tw-text-slate-700">
        <div>Primary Contact: {{ carrier.primaryContactName }}</div>
        <div>Primary Contact Phone #: {{ carrier.primaryContactPhoneNumber }}</div>
        <div>Accounting Email: {{ carrier.accountingEmail }}</div>
        <div>MC #: {{ carrier.mcNumber }}</div>
        <div>DOT #: {{ carrier.dotNumber }}</div>
        <div>FID #: {{ carrier.fidNumber }}</div>
        <div>Dispatch Phone #: {{ carrier.dispatchPhoneNumber }}</div>
        <div>After Hours Phone #: {{ carrier.afterHoursPhoneNumber }}</div>
        <div>Fax #: {{ carrier.faxNumber }}</div>
        <div class="md:tw-col-span-2">Address: {{ fullAddress(carrier.officeAddress) }}</div>
        <div># Owner/Operator Drivers: {{ carrier.numOwnerOpDrivers }}</div>
        <div># Company Drivers: {{ carrier.numCompanyDrivers }}</div>
        <div>Transports TL: {{ carrier.doesTransportTl ? carrier.doesTransportTl.toString() : 'false' }}</div>
        <div>Transports LTL: {{ carrier.doesTransportLtl ? carrier.doesTransportLtl.toString() : 'false' }}</div>
        <div class="md:tw-col-span-2">Preferred Lanes: {{ carrier.preferredLanes }}</div>
        <div># Tractors: {{ carrier.numTractors }}</div>
        <div># 45 Flat Vans: {{ carrier.num45FlatVans }}</div>
        <div># 48 Flat Vans: {{ carrier.num48FlatVans }}</div>
        <div># 53 Flat Vans: {{ carrier.num53FlatVans }}</div>
        <div># Reefers: {{ carrier.numReefers }}</div>
        <div># Step Decks: {{ carrier.numStepDecks }}</div>
        <div># 4 Tarps: {{ carrier.num4Tarps }}</div>
        <div># 6 Tarps: {{ carrier.num6Tarps }}</div>
        <div># 8 Tarps: {{ carrier.num8Tarps }}</div>
        <div># Coil Racks: {{ carrier.numCoilRacks }}</div>
        <div># Pipe Stakes: {{ carrier.numPipeStakes }}</div>
      </div>
    </div>

    <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4">
      <div class="tw-text-sm tw-font-semibold tw-text-slate-900">Documents</div>
      <div class="tw-mt-3 tw-space-y-2">
        <div
          v-for="onboardingDoc in brokerCarrierAssociation.onboardingDocs"
          :key="onboardingDoc.id"
          class="tw-text-sm tw-text-slate-700"
        >
          <span class="tw-font-medium tw-text-slate-900">{{ displayDocTypeName(onboardingDoc.docType) }}</span>
          <span class="tw-text-slate-500"> — </span>
          <a class="tw-font-medium tw-text-slate-900 hover:tw-underline" :href="onboardingDoc.docFileUrl" target="_blank">{{ onboardingDoc.docFileUrl }}</a>
        </div>

        <a
          class="tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white"
          :href="combinedOnboardingDocsPdfUrl"
          target="_blank"
        >
          Download all data and files as single PDF
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UpdateCustomerName from '@/gql/customers/UpdateCustomerName.gql';
import { datetimeFormatMixin } from '../../utils/date';
import { displayDocTypeNameMixin } from '../../utils/onboarding_docs';
import { addressMixin } from '../../utils/address';

export default defineComponent({
  name: 'CarrierDetailModal',
  props: {
    brokerCarrierAssociation: Object,
  },
  mixins: [addressMixin, datetimeFormatMixin, displayDocTypeNameMixin],
  components: {},

  computed: {
    broker() {
      return this.brokerCarrierAssociation.company1;
    },
    carrier() {
      return this.brokerCarrierAssociation.company2;
    },
    combinedOnboardingDocsPdfUrl() {
      return `${process.env.VUE_APP_SERVER_URL}/pdf/onboarding/combined_pdf/${
        (this as any).broker.id
      }/${(this as any).carrier.id}`;
    },
  },

  methods: {
    getCarrierOnboardingUrl() {
      return `/onboarding/${(this as any).broker.id}/${
        (this as any).carrier.id
      }`;
    },
  },
});
</script>
